module.exports = __webpack_public_path__ + "static/media/8.a0286865.jpg";